/* eslint-disable */
export default {
  setLang (lang) {
    window.localStorage.setItem('user_lang', lang)
  },
  getLang (defaultLang) {
    let localLang = window.localStorage.getItem('user_lang')
    if (!localLang) {
      return defaultLang
    } else {
      return localLang
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/cookie.js